"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QueryRenderer;

var _react = require("react");

var _reactRelay = require("react-relay");

var _js = require("@adeira/js");

var _fetch = require("@adeira/fetch");

var _jsxRuntime = require("react/jsx-runtime");

function QueryRenderer(props) {
  var _props$environment, _props$variables;

  function renderQueryRendererResponse(_ref) {
    var error = _ref.error,
        rendererProps = _ref.props,
        retry = _ref.retry;

    if (error) {
      if (props.onSystemError) {
        return props.onSystemError({
          error: error,
          retry: retry
        });
      }

      var publicErrorMessage = 'Error!';

      if (error instanceof _fetch.TimeoutError) {
        publicErrorMessage = 'Timeout error!';
      } else if (error instanceof _fetch.ResponseError) {
        var response = error.response;
        publicErrorMessage = (0, _js.sprintf)('Unsuccessful response! (%s - %s)', response.status, response.statusText); // You can get the actual response here:
        // error.response.json().then(data => console.warn(data));
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-testid": "error",
        children: [publicErrorMessage, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          onClick: retry,
          children: "Retry"
        })]
      });
    }

    if (rendererProps == null) {
      return props.onLoading ? props.onLoading() : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-testid": "loading",
        children: "Loading..."
      });
    }

    !(props.onResponse !== undefined) ? process.env.NODE_ENV !== "production" ? (0, _js.invariant)(false, 'QueryRenderer used default render function but "onResponse" property has not been provided.') : (0, _js.invariant)(false) : void 0;
    return props.onResponse(rendererProps);
  } // 1) <QR environment={Env} /> always win
  // 2) <QR /> checks whether we provide Environment via `RelayEnvironmentProvider`
  // 3) throw if no environment is set


  var context = (0, _react.useContext)(_reactRelay.ReactRelayContext);
  var environment = (_props$environment = props.environment) !== null && _props$environment !== void 0 ? _props$environment : context === null || context === void 0 ? void 0 : context.environment;
  !(environment != null) ? process.env.NODE_ENV !== "production" ? (0, _js.invariant)(false, 'QueryRenderer: Expected to have found a Relay environment provided by a `RelayEnvironmentProvider` component or by environment property.') : (0, _js.invariant)(false) : void 0; // Use this to disable store GC in order to reuse already existing data between screens:
  // const disposable = environment.getStore().holdGC();
  // Relay QR itself recreates the context with our environment.
  // Relay hooks are using `useRelayEnvironment` with `ReactRelayContext` inside (so we use it as well).

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRelay.QueryRenderer, {
    environment: environment,
    render: props.render !== undefined ? props.render : renderQueryRendererResponse,
    query: props.query,
    cacheConfig: props.cacheConfig,
    fetchPolicy: props.fetchPolicy,
    variables: (_props$variables = props.variables) !== null && _props$variables !== void 0 ? _props$variables : {}
  });
}